import {handleData} from "../utils/handleData";

export function getImagesForPost(type, timelineElement) {
    $.ajax({
        type: "POST",
        url: "/module/community/ajax.php?action=get_images_for_post",
        datatype: "json",
        data: {
            "ajax_call_id": timelineElement.id,
            "ajax_call_type": type
        },
        success: function (output) {
            handleData(output, timelineElement);
        }
    });
}